import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DEFAULT_ERROR_MESSAGE, FIREBASE_EVENTS, NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { Button, Card, RadioButton } from 'components'
import { useFirebaseEvent } from 'hooks'
import { serviceOrderService } from 'services'
import { STATICS } from 'statics'
import { sendWhatsappMessage } from 'utils'
import { setDrawer, setDrawerAlert, setStage } from 'slices/drawer'
import { INELIGIBLE_CONTRACT_ERROR_MESSAGE } from './constants'
import './style.scss'

export function SelectAddress({
  contractAddressSelected,
  setContractAddressSelected,
  serviceOrderMassive,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { selected } = useSelector(state => state.contract)
  const { getServiceOrderContractEligible } = serviceOrderService()

  function handleClose() {
    dispatch(setDrawer(''))
  }

  async function handleContinue() {
    const event = serviceOrderMassive
      ? FIREBASE_EVENTS.UNITARY_WARNING_ADDRESS_CONFIRM
      : FIREBASE_EVENTS.VIRTUAL_SUPPORT_CONFIRM_ADDRESS
    sendEvent(event)
    setIsLoading(true)

    try {
      const {
        data: { eligible: isEligible },
      } = await getServiceOrderContractEligible(contractAddressSelected.id)

      if (isEligible) {
        dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.SCHEDULING_SERVICE_ORDER))
      } else {
        dispatch(setDrawerAlert({ severity: 'error', title: INELIGIBLE_CONTRACT_ERROR_MESSAGE }))
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || DEFAULT_ERROR_MESSAGE
      console.error(error)
      dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
    } finally {
      setIsLoading(false)
    }
  }

  function handleSelectContractAddress(contract) {
    setContractAddressSelected(contract)
  }

  function handleHelpClick() {
    const event = serviceOrderMassive
      ? FIREBASE_EVENTS.UNITARY_WARNING_TALK_WITH_ATTENDENT
      : FIREBASE_EVENTS.VIRTUAL_SUPPORT_TALK_WITH_ATTENDENT
    sendEvent(event)
    sendWhatsappMessage({})
  }

  // TODO silva.william 12/08/2026: Necessário alterar o uso do endereço caso ele vire um array de endereços e não um objeto.
  function renderCards() {
    return (
      <Card
        className={`card ${contractAddressSelected === selected ? '-selected' : ''}`}
        onClick={() => handleSelectContractAddress(selected)}
        key={selected.id}
      >
        <RadioButton id={selected.id} checked={contractAddressSelected === selected} />
        <div className='card-content'>
          <div className='tag'>
            <p>CONTRATO {selected.id}</p>
          </div>
          <p className='text'>
            {`${selected.address.street}, ${selected.address.number}, ${selected.address.neighborhood} - ${selected.address.city}, ${selected.address.uf}`}
          </p>
          <p className='text'>CEP: {selected.address.zipCode}</p>
        </div>
      </Card>
    )
  }

  function renderHelpCard() {
    return (
      <div className='container-help'>
        <span className='title'>Precisa de ajuda com o endereço?</span>
        <span className='description'>
          Se o endereço informado não estiver correto, entre em contato com nosso atendimento para
          que possamos ajudar.
        </span>
        <button type='button' className='button' onClick={handleHelpClick}>
          Falar com atendimento <STATICS.ARROW_NEXT />
        </button>
      </div>
    )
  }

  function renderButtons() {
    return (
      <div className='container-actions'>
        <Button
          className='button'
          color='primary'
          size='large'
          onClick={() => handleContinue()}
          disabled={!contractAddressSelected}
          isLoading={isLoading}
        >
          Continuar
        </Button>
        <Button
          className='button last'
          color='primary'
          size='large'
          outlined
          onClick={() => {
            handleClose()
          }}
        >
          Cancelar
        </Button>
      </div>
    )
  }

  return (
    <div className='virtual-support-info'>
      <div className='content'>
        <h3 className='title'>Você está no suporte virtual</h3>
        <p className='subtitle'>Para iniciar, selecione o endereço que necessita de reparo</p>
        {renderCards()}
      </div>
      {renderHelpCard()}
      {renderButtons()}
    </div>
  )
}
